import { UseQueryResult, useQuery } from "react-query";
import { searchServiceOrdersResponse, searchServiceOrders } from "../../../../entities/service-order/api/search-service-orders";

export interface UseListServiceOrderProps {
  term: string;
  startDate: Date;
  endDate: Date;
  page: number;
  limit: number;
  shouldListByDate: boolean;
  enabled: boolean;
}

export const queryKeys = {
  listServiceOrders: (props: UseListServiceOrderProps) => ["listServiceOrders", props]
};

export function useListServiceOrders(props: UseListServiceOrderProps): UseQueryResult<searchServiceOrdersResponse, Error> {
  const { term, page, limit, enabled } = props;

  return useQuery(
    queryKeys.listServiceOrders(props),
    async () => {
      const result = await searchServiceOrders({
        search_term: term,
        page_limit: limit,
        page_offset: (page - 1) * limit
      });
      
      if (result.error) {
        throw new Error(result.error.message || "Error searching service orders");
      }
      
      return result.data;
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: enabled
    }
  );
}
